import { RouteRecordRaw } from 'vue-router'

import { LayoutSupportSuspense } from '@/pages/suspense'

import { UserRoles } from '@/shared/types/router'

export const useSupportLayout = (routeRecord: RouteRecordRaw): RouteRecordRaw => {
  if (!routeRecord.meta) {
    routeRecord.meta = {}
  }
  routeRecord.meta.layout = LayoutSupportSuspense
  routeRecord.meta.roles = [UserRoles.SUPPORT]

  return routeRecord
}
